import { StrictMode } from 'react'
import type { Root } from 'react-dom/client'
import { App } from '@/App'
import { StartupError } from '@/components/startup/startup-error'
import { VisitOneProvider } from '@/components/visitone/visitone-provider'
import type { ConfigProblem } from '@/lib/config/runtime-config'

/* Mounts the app. Call only after the runtime configuration has loaded. */
export function renderApp(root: Root) {
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

/* Mounts the startup error in place of the app, without Auth0 or any BFF call. */
export function renderStartupError(root: Root, problems: ConfigProblem[]) {
  root.render(
    <StrictMode>
      <VisitOneProvider>
        <StartupError problems={problems} />
      </VisitOneProvider>
    </StrictMode>,
  )
}
